<template>
  <vx-card class="flex flex-col justify-between editor-right-bar z-10">
    <div class="mb-4 h-full">
      <div v-if="organizationSlug === 'gala'">
        <h3 class="mb-1">Character</h3>
        <!-- <p class="mb-4">
          {{ $t('editor.editorRightBar.buildYourTalentProfileWith', { organizationName: organizationDetails.name }) }}
        </p> -->

        <div
          class="flex items-center justify-center avatar-height"
          v-if="selectedGalaAvatar && selectedGalaAvatarGender"
        >
          <vs-tooltip :text="selectedGalaAvatar">
            <img
              v-if="selectedGalaAvatar && selectedGalaAvatarGender"
              :src="
                galaAvatar
                  ? require(`@/assets/images/gala-images/Avatar/${selectedGalaAvatarGender}/${selectedGalaAvatar}.png`)
                  : ''
              "
              :alt="selectedGalaAvatar ? selectedGalaAvatar : ''"
              class="object-contain p-6"
              width="250px"
              height="250px"
            />
          </vs-tooltip>
        </div>
        <div class="flex items-center justify-center avatar-height" v-else>
          <vs-tooltip text="Monk">
            <img
              :src="
                galaAvatar
                  ? require(`@/assets/images/gala-images/Avatar/${selectedGalaAvatarGender}/Monk.png`)
                  : ''
              "
              :alt="selectedGalaAvatar ? selectedGalaAvatar : ''"
              class="object-contain p-6"
              width="250px"
              height="250px"
            />
          </vs-tooltip>
        </div>

        <!--        <div v-else class="m-20 my-0">-->
        <!--          <img-->
        <!--            :src="-->
        <!--              require(`@/assets/images/gala-images/Avatar/defaultcharacter.png`)-->
        <!--            "-->
        <!--            width="100%"-->
        <!--            height="100%"-->
        <!--          />-->
        <!--        </div>-->
      </div>
      <div v-else-if="!organizationDetails.activeMarketplace" class="">
        <h3 class="mb-1">{{ $t("editor.editorRightBar.talentCard") }}</h3>
        <p class="mb-4">
          {{
            $t("editor.editorRightBar.buildYourTalentProfileWith", {
              organizationName: organizationDetails.name,
            })
          }}
        </p>
        <div
          v-if="templateColorCode && tmc[resumeTemplate]"
          class="resume-template"
        >
          <img
            :src="tmc[resumeTemplate][templateColorCode]"
            width="100%"
          />
        </div>
        <div
          v-else-if="
            organizationDetails.colorSet &&
            organizationDetails.colorSet[0] &&
            tmc[resumeTemplate]
          "
          class="resume-template m-20 my-0"
        >
          <img
            :src="tmc[resumeTemplate][organizationDetails.colorSet[0]]"
            width="100%"
            height="100%"
          />
        </div>
      </div>
      <div v-else>
        <h3 class="mb-1">{{ $t("editor.editorRightBar.alex") }}</h3>
        <p>{{ $t("editor.editorRightBar.alexForContinuousLearning") }}</p>
        <div class="items-center">
          <img
            class="cursor-pointer"
            src="@/assets/images/icons/alex/alex-bot-icon.png"
            width="240px"
            @click="$router.push(`/${organizationSlug}/alex`)"
          />
        </div>
        <!-- <div class="vx-row">
          <div class="vx-col mb-3 w-1/2">
            <div
              class="template-options-btn"
              @click="$router.push(`/${organizationSlug}/alex`)"
            >
              <vx-tooltip
                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                position="bottom"
              >
                <span
                  class="
                    template-options-btn-icon
                    p-2
                    inline-flex
                    feather-icon
                    text-primary
                    mr-3
                  "
                  style="
                    background: linear-gradient(
                      137.44deg,
                      #fba727 0.01%,
                      #ffd088 103.87%
                    );
                    border-radius: 10px;
                  "
                >
                  <img
                    src="@/assets/images/icons/app-marketplace/alex.svg"
                    width="20px"
                    height="20px"
                  />
                </span>
                <span class="template-options-btn-text">ALEX</span>
              </vx-tooltip>
            </div>
          </div>
          <div class="vx-col mb-3 w-1/2">
            <div class="template-options-btn">
              <vx-tooltip
                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                position="bottom"
              >
                <span
                  class="
                    template-options-btn-icon
                    p-2
                    inline-flex
                    feather-icon
                    text-primary
                    mr-3
                  "
                  style="
                    background: linear-gradient(
                      137.44deg,
                      #fba727 0.01%,
                      #ffd088 103.87%
                    );
                    border-radius: 10px;
                  "
                >
                  <img
                    src="@/assets/images/icons/app-marketplace/opex.svg"
                    width="20px"
                    height="20px"
                  />
                </span>
                <span class="template-options-btn-text">OPEX</span>
              </vx-tooltip>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col mb-3 w-1/2">
            <div class="template-options-btn">
              <vx-tooltip
                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                position="bottom"
              >
                <span
                  class="
                    template-options-btn-icon
                    p-2
                    inline-flex
                    feather-icon
                    text-primary
                    mr-3
                  "
                  style="
                    background: linear-gradient(
                      137.44deg,
                      #fba727 0.01%,
                      #ffd088 103.87%
                    );
                    border-radius: 10px;
                  "
                >
                  <img
                    src="@/assets/images/icons/app-marketplace/dex.svg"
                    width="20px"
                    height="20px"
                  />
                </span>
                <span class="template-options-btn-text">DEX</span>
              </vx-tooltip>
            </div>
          </div>
          <div class="vx-col mb-3 w-1/2">
            <div class="template-options-btn">
              <vx-tooltip
                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                position="bottom"
              >
                <span
                  class="
                    template-options-btn-icon
                    p-2
                    inline-flex
                    feather-icon
                    text-primary
                    mr-3
                  "
                  style="
                    background: linear-gradient(
                      137.44deg,
                      #84b334 0.01%,
                      #a7ca6b 103.87%
                    );
                    border-radius: 10px;
                  "
                >
                  <img
                    src="@/assets/images/icons/app-marketplace/mycoach.svg"
                    width="20px"
                    height="20px"
                  />
                </span>
                <span class="template-options-btn-text">MyCoach</span>
              </vx-tooltip>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="items-center"><span id="v-step-5"></span></div>
    <div class="resume-config">
      <div class="mb-base">
        <div
          class="flex justify-between flex-wrap"
          style="align-items: flex-start"
        >
          <h3 class="mb-4">
            {{ $t("editor.editorRightBar.templateOptions") }}
          </h3>
          <i18n class="mt-1" />
        </div>
        <div class="vx-row">
          <div class="vx-col mb-3 w-1/2">
            <vs-popup
              title="Choose a Template"
              :active.sync="showResumeTemplates"
            >
              <div class="vx-row" v-if="organizationSlug === 'gala'">
                <div class="vx-col w-1/2 items-center">
                  <div
                    class="cursor-pointer"
                    @click.stop="updateResumeTemplate('lightcharactercard')"
                  >
                    <div
                      v-if="templateColorCode"
                      class="resume-template shadow hover:shadow-lg mb-base"
                    >
                      <img
                        :src="tmc['lightcharactercard'][templateColorCode]"
                        width="100%"
                        height="300px"
                      />
                    </div>
                    <div
                      v-else-if="organizationDetails.colorSet[0]"
                      class="resume-template shadow hover:shadow-lg m-5 mb-base"
                    >
                      <img
                        :src="
                          tmc['lightcharactercard'][
                            organizationDetails.colorSet[0]
                          ]
                        "
                        width="100%"
                        height="300px"
                      />
                    </div>
                    <h4>Character Card-Light</h4>
                  </div>
                </div>

                <div class="vx-col w-1/2 items-center">
                  <div
                    class="cursor-pointer"
                    @click.stop="updateResumeTemplate('darkcharactercard')"
                  >
                    <div
                      v-if="templateColorCode"
                      class="resume-template shadow hover:shadow-lg mb-base"
                    >
                      <img
                        :src="tmc['darkcharactercard'][templateColorCode]"
                        width="100%"
                        height="300px"
                      />
                    </div>
                    <div
                      v-else-if="organizationDetails.colorSet[0]"
                      class="resume-template shadow hover:shadow-lg m-5 mb-base"
                    >
                      <img
                        :src="
                          tmc['darkcharactercard'][
                            organizationDetails.colorSet[0]
                          ]
                        "
                        width="100%"
                        height="300px"
                      />
                    </div>
                    <h4>Character Card-Dark</h4>
                  </div>
                </div>
              </div>
              <div v-else class="vx-row">
                <div class="vx-col w-1/2 items-center">
                  <div
                    class="cursor-pointer"
                    @click.stop="updateResumeTemplate('prestige')"
                  >
                    <div
                      v-if="templateColorCode"
                      class="resume-template shadow hover:shadow-lg mb-base"
                    >
                      <img
                        :src="tmc['prestige'][templateColorCode]"
                        width="100%"
                        height="300px"
                      />
                    </div>
                    <div
                      v-else-if="organizationDetails.colorSet[0]"
                      class="resume-template shadow hover:shadow-lg m-5 mb-base"
                    >
                      <img
                        :src="tmc['prestige'][organizationDetails.colorSet[0]]"
                        width="100%"
                        height="300px"
                      />
                    </div>
                    <h4>Prestige</h4>
                  </div>
                </div>
                <div
                  class="vx-col w-1/2 items-center"
                  @click.stop="updateResumeTemplate('greyline')"
                >
                  <div
                    class="cursor-pointer"
                    @click.stop="updateResumeTemplate('greyline')"
                  >
                    <div
                      v-if="templateColorCode"
                      class="resume-template shadow hover:shadow-lg mb-base"
                    >
                      <img
                        :src="tmc['greyline'][templateColorCode]"
                        width="100%"
                        height="300px"
                      />
                    </div>
                    <div
                      v-else-if="organizationDetails.colorSet[0]"
                      class="resume-template shadow hover:shadow-lg mb-base"
                    >
                      <img
                        :src="tmc['greyline'][organizationDetails.colorSet[0]]"
                        width="100%"
                        height="300px"
                      />
                    </div>
                    <h4>GreyLine</h4>
                  </div>
                </div>
              </div>
            </vs-popup>
            <div
              class="template-options-btn"
              @click.stop="showResumeTemplates = true"
            >
              <feather-icon
                class="template-options-btn-icon mr-2"
                svgClasses="text-primary"
                icon="FileTextIcon"
              />
              <span class="template-options-btn-text">{{
                $t("editor.editorRightBar.template")
              }}</span>
            </div>
          </div>
          <div class="vx-col mb-3 w-1/2">
            <div
              class="template-options-btn"
              :class="{ 'template-options-btn--selected': this.previewMode }"
              @click.stop="showResumePreview()"
            >
              <feather-icon
                class="template-options-btn-icon mr-2"
                svgClasses="text-primary"
                icon="EyeIcon"
              />
              <span class="template-options-btn-text">{{
                $t("editor.editorRightBar.preview")
              }}</span>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col mb-3 w-1/2">
            <div
              class="template-options-btn"
              :class="{
                'template-options-btn--selected':
                  this.usersData.resumeStatus === 'published',
              }"
              @click.stop="publishResume()"
            >
              <feather-icon
                class="template-options-btn-icon mr-2"
                svgClasses="text-primary"
                icon="MonitorIcon"
              />
              <span class="template-options-btn-text">{{
                $t("editor.editorRightBar.published")
              }}</span>
            </div>
          </div>
          <div class="vx-col mb-3 w-1/2">
            <div
              class="template-options-btn"
              :class="{
                'template-options-btn--selected':
                  this.usersData.resumeStatus === 'private',
              }"
              @click.stop="unpublishResume()"
            >
              <feather-icon
                class="template-options-btn-icon mr-2"
                svgClasses="text-primary"
                icon="LockIcon"
              />
              <span class="template-options-btn-text">{{
                $t("editor.editorRightBar.private")
              }}</span>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <!-- <div class="vx-col mb-3 w-1/2">
            <div class="template-options-btn">
              <feather-icon
                class="template-options-btn-icon mr-2"
                svgClasses="text-primary"
                icon="CopyIcon"
              />
              <span class="template-options-btn-text">{{ $t('editor.editorRightBar.copyLink') }}</span>
            </div>
          </div> -->
          <!-- <div
            v-if="usersData.resumeStatus === 'published'"
            class="vx-col mb-3 w-1/2"
          >
            <router-link
              :to="
                organizationSlug
                  ? `/${organizationSlug}/profile/${usersData.slug}`
                  : `/profile/${usersData.slug}`
              "
              target="_blank"
            >
              <div class="template-options-btn">
                <feather-icon
                  class="template-options-btn-icon mr-2"
                  svgClasses="text-primary"
                  icon="LinkIcon"
                />
                <span class="template-options-btn-text">Share</span>
              </div>
            </router-link>
          </div>
          <div v-else class="vx-col mb-3 w-1/2">
            <div class="template-options-btn disabled">
              <feather-icon
                class="template-options-btn-icon mr-2"
                svgClasses="text-primary"
                icon="LinkIcon"
              />
              <span class="template-options-btn-text">Share</span>
            </div>
          </div>
          <div class="vx-col mb-3 w-1/2">
            <div class="template-options-btn" @click.stop="downloadResume()">
              <feather-icon
                class="template-options-btn-icon mr-2"
                svgClasses="text-primary"
                icon="DownloadIcon"
              />
              <span class="template-options-btn-text">{{
                $t("editor.editorRightBar.download")
              }}</span>
            </div>
          </div> -->
        </div>
      </div>
      <div>
        <h3 class="mb-4">{{ $t("editor.editorRightBar.colorSettings") }}</h3>
        <vs-row class="color-settings justify-between">
          <div
            v-for="(cs, index) in organizationDetails.colorSet"
            :key="index"
            class="colorset-item items-center"
            @click.stop="saveTemplateColorCode(cs)"
            :style="{ backgroundColor: cs }"
          >
            <feather-icon
              v-if="templateColorCode === cs"
              class="primarycolor-check-icon"
              icon="CheckCircleIcon"
              svgClasses="text-white w-5 h-5"
            />
          </div>
        </vs-row>
      </div>
    </div>
  </vx-card>
</template>

<script>
import { saveInputFieldService } from "@/services/editor/about.service.js";
import constants from "@/constants";
import VxTooltip from "../../vx-tooltip/VxTooltip.vue";
import i18n from "./I18n.vue";
import organizationConfig from "@/assets/data/organization-config.js";

export default {
  components: { VxTooltip, i18n },
  data() {
    return {
      constants,
      tmc: {
        prestige: {
          "#3BA0BE": require("@/assets/images/resume-template-thumbnail/prestige/blue.png"),
          "#6859B4": require("@/assets/images/resume-template-thumbnail/prestige/purple.png"),
          "#008000": require("@/assets/images/resume-template-thumbnail/prestige/green.png"),
          "#B3B3B3": require("@/assets/images/resume-template-thumbnail/prestige/grey.png"),
          "#C6211B": require("@/assets/images/resume-template-thumbnail/prestige/red.png"),
          "#E4D033": require("@/assets/images/resume-template-thumbnail/prestige/yellow.png"),
          "#EA7526": require("@/assets/images/resume-template-thumbnail/prestige/orange.png"),
          "#F36677": require("@/assets/images/resume-template-thumbnail/prestige/pink.png"),
        },
        greyline: {
          "#3BA0BE": require("@/assets/images/resume-template-thumbnail/greyline/blue.png"),
          "#6859B4": require("@/assets/images/resume-template-thumbnail/greyline/purple.png"),
          "#008000": require("@/assets/images/resume-template-thumbnail/greyline/green.png"),
          "#B3B3B3": require("@/assets/images/resume-template-thumbnail/greyline/grey.png"),
          "#C6211B": require("@/assets/images/resume-template-thumbnail/greyline/red.png"),
          "#E4D033": require("@/assets/images/resume-template-thumbnail/greyline/yellow.png"),
          "#EA7526": require("@/assets/images/resume-template-thumbnail/greyline/orange.png"),
          "#F36677": require("@/assets/images/resume-template-thumbnail/greyline/pink.png"),
        },
        lightcharactercard: {
          "#3BA0BE": require("@/assets/images/resume-template-thumbnail/charactercard/lighttheme/purple.png"),
          "#6859B4": require("@/assets/images/resume-template-thumbnail/charactercard/lighttheme/purple.png"),
          "#008000": require("@/assets/images/resume-template-thumbnail/charactercard/lighttheme/purple.png"),
          "#B3B3B3": require("@/assets/images/resume-template-thumbnail/charactercard/lighttheme/purple.png"),
          "#C6211B": require("@/assets/images/resume-template-thumbnail/charactercard/lighttheme/purple.png"),
          "#E4D033": require("@/assets/images/resume-template-thumbnail/charactercard/lighttheme/purple.png"),
          "#EA7526": require("@/assets/images/resume-template-thumbnail/charactercard/lighttheme/purple.png"),
          "#F36677": require("@/assets/images/resume-template-thumbnail/charactercard/lighttheme/purple.png"),
        },
        darkcharactercard: {
          "#3BA0BE": require("@/assets/images/resume-template-thumbnail/charactercard/darktheme/purple.png"),
          "#6859B4": require("@/assets/images/resume-template-thumbnail/charactercard/darktheme/purple.png"),
          "#008000": require("@/assets/images/resume-template-thumbnail/charactercard/darktheme/purple.png"),
          "#B3B3B3": require("@/assets/images/resume-template-thumbnail/charactercard/darktheme/purple.png"),
          "#C6211B": require("@/assets/images/resume-template-thumbnail/charactercard/darktheme/purple.png"),
          "#E4D033": require("@/assets/images/resume-template-thumbnail/charactercard/darktheme/purple.png"),
          "#EA7526": require("@/assets/images/resume-template-thumbnail/charactercard/darktheme/purple.png"),
          "#F36677": require("@/assets/images/resume-template-thumbnail/charactercard/darktheme/purple.png"),
        },
      },
      organizationConfig,
      showResumeTemplates: false,
      // iFrameDetection: false,
      selectedGalaAvatar: "",
      selectedGalaAvatarGender: "",
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    galaAvatar() {
      return (
        this.$store.state.users.galaAvatar.charAt(0).toUpperCase() +
        this.$store.state.users.galaAvatar.slice(1)
      );
    },
    /* galaAvatar() {
      return this.$store.state.users.galaAvatar;
    }, */
    userId() {
      return this.$store.state.auth.user._id;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    previewMode() {
      return this.$store.state.editor.previewMode;
    },
    colorSet() {
      return this.$store.state.organization.orgData.colorSet;
    },
    editorTitle() {
      return this.$store.state.organization.orgData.editorTitle;
    },
    activeMarketplace() {
      return this.$store.state.organization.orgData.activeMarketplace;
    },
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
    templateColorCode() {
      return this.$store.state.users.data.templateColorCode;
    },
    /*organizationId() {
        return this.$store.state.organization.orgData._id;
      },*/
    organizationDetails() {
      return this.organizationConfig[this.organizationSlug];
    },
    /*organizationLogo() {
        return this.organizationConfig[this.organizationSlug].logo;
      },*/
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
    resumeTemplate() {
      if (this.usersData && this.isUserLoggedIn) {
        return this.usersData.resumeTemplate;
      } else return "prestige";
    },
  },
  watch: {
    usersData(newVal) {
      if (newVal) {
        //// console.log(newVal);
        this.localData = JSON.parse(JSON.stringify(newVal));
        if (this.localData.dob) {
          this.localData.dob = this.localData.dob.split("T")[0];
        }
      }
    },
    galaAvatar: {
      handler(val) {
        if (val.split("-")[0]) {
          this.selectedGalaAvatar = val.split("-")[0];
        } else {
          this.selectedGalaAvatar = "monk";
        }

        if (val.split("-")[1]) {
          this.selectedGalaAvatarGender = val.split("-")[1];
        } else if (this.usersData && this.usersData.gender) {
          this.selectedGalaAvatarGender = this.usersData.gender;
        } else {
          this.selectedGalaAvatarGender = "male";
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    updateResumeTemplate(resumeTemplate) {
      this.$vs.loading();
      const resumeTemplateObj = {
        userId: this.usersData._id,
        resumeTemplate,
      };
      this.$store
        .dispatch("users/updateResumeTemplate", resumeTemplateObj)
        .then((res) => {
          this.$vs.loading.close();
          this.showResumeTemplates = false;
          window.location.href = window.location.href;
        })
        .catch((err) => {
          throw err;
        });
    },
    publishResume() {
      if (this.usersData.resumeStatus === "published") return;

      const publishObj = {
        userId: this.usersData._id,
        resumeStatus: "published",
      };
      this.$store
        .dispatch("users/updateResumeStatus", publishObj)
        .catch((err) => {
          throw err;
        });
    },
    unpublishResume() {
      if (this.usersData.resumeStatus === "private") return;

      const publishObj = {
        userId: this.usersData._id,
        resumeStatus: "private",
      };
      this.$store
        .dispatch("users/updateResumeStatus", publishObj)
        .catch((err) => {
          throw err;
        });
    },
    showResumePreview() {
      this.$store.dispatch("editor/toggleRightBar", false);
      console.log(this.organizationSlug);
      if (this.organizationSlug === "default")
        this.$router.push({ name: "editor-preview" });
      else if (this.organizationSlug === "gala")
        this.$router.push({ name: "editor-preview-org" });
      else this.$router.push({ name: "editor-preview-custom" });
    },
    downloadResume() {
      if (!this.isUserLoggedIn) return;

      this.$vs.loading();
 // Terminated when resume pdf is generated successfully
      // // console.log('generating pdf');
      let currentThis = this;
      setTimeout(function () {
        currentThis.$root.$emit("downloadResume");
      }, 500);
    },
    saveTemplateColorCode(color) {
      if (!this.isUserLoggedIn) return;

      // this.$vs.loading();
 // Closed in World Map

      this.localData.templateColorCode = color;

      this.saveField("saveTemplateColorCode");
    },
    async saveField(action, fieldName = null) {
      if (!this.isUserLoggedIn) return;

      let fieldIsValid = false;

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        userId: this.userId,
        currentThis: this,
      };

      saveInputFieldService(payload);

      /*_.debounce(
            function () {

            },
            800,
            { leading: false, trailing: true }
          )();*/
    },
  },
  created() {
    // this.$store.dispatch("editor/toggleRightBar", true);
    // this.$store.dispatch("editor/togglePreviewMode", false);

    if (this.isUserLoggedIn) {
      if (Object.keys(this.usersData).length) {
        this.localData = JSON.parse(JSON.stringify(this.usersData));
        if (this.localData.dob) {
          this.localData.dob = this.localData.dob.split("T")[0];
        }
      }

      // this.$store.commit("auth/SET_OTP_STATUS", true);
    }
  },
};
</script>

<style scoped>
.resume-template {
  background: #ffffff;
  border: 1px solid #e9e9ff;
  box-sizing: border-box;
  border-radius: 8px;
  height: 80%;
}

button {
  border-radius: 6px;
}

.editor-right-bar.vx-card >>> .vx-card__collapsible-content {
  height: 100% !important;
}

.editor-right-bar.vx-card >>> .vx-card__collapsible-content .vx-card__body {
  position: relative !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.resume-config {
  margin-top: 1.5em;
}
.template-options-btn {
  background: #ffffff;
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  border-radius: 6px;

  padding: 10px 15px;
  cursor: pointer;
  width: 100%;
}

.template-options-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.template-options-btn:hover {
  background: rgba(242, 146, 0, 0.1);
  border: 1px solid #f29200;
}

.template-options-btn.disabled:hover {
  background: #ffffff;
  border: 1px solid #f4f4f4;
}

.template-options-btn--selected {
  background: rgba(242, 146, 0, 0.1);
  border: 1px solid #f29200;
}

.template-options-btn-icon {
  vertical-align: middle;
}

.template-options-btn-text {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #888888;

  vertical-align: middle;
}

.template-options-btn:hover .template-options-btn-text {
  color: #f29200 !important;
}

.template-options-btn.disabled:hover .template-options-btn-text {
  color: #888888 !important;
}

.template-options-btn--selected .template-options-btn-text {
  color: #f29200 !important;
}

.primarycolor-check-icon {
  top: calc(50% - 10px);
}

.color-settings div {
  border-radius: 6px;
  width: 10.5%;
  height: 40px;
  cursor: pointer;
}

.color-settings .green {
  background: #008000;
}

.color-settings .blue {
  background: #3ba0be;
}

.color-settings .purple {
  background: #6859b4;
}

.color-settings .yellow {
  background: #e4d033;
}

.color-settings .orange {
  background: #ea7526;
}

.color-settings .red {
  background: #c6211b;
}

.color-settings .pink {
  background: #f36677;
}

.color-settings .gray {
  background: #b3b3b3;
}

.colorset-item--active {
  height: 50px !important;
}

.disabled-btn {
  opacity: 50%;
  cursor: default;
}
.avatar-height {
  height: 20em;
}

/* .avatar-height--iFrame {
  height: 20em;
} */

@media only screen and (max-width: 991px) {
  .editor-right-bar >>> .vx-card__collapsible-content .vx-card__body {
    overflow: scroll !important;
  }

  .resume-config {
    position: relative !important;
    left: 0 !important;
    right: 0 !important;
  }
}
</style>
